import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useBlocker } from "react-router-dom";
import { RootState } from "../../store";
import websocketTranscriptService from "src/pages/ManageStudies/serviceHelper/socketTranscriptService";
import websocketDiscussionGuideService from "src/pages/ManageStudies/serviceHelper/socketDGService";
import { fileTypes } from "src/pages/Studies/models/interfaces";
import websocketReportService from "src/pages/Reports/serviceHelper/socketReportsService";
import { ModuleType } from "../SubHeader/interface";
import { hasUnsavedChangesReports } from "src/pages/Reports/transformer";

const LeavePagePrompt: React.FC<{ module_type?: string; onConfirm: () => void }> = ({ module_type, onConfirm }) => {
	const { t } = useTranslation();
	const { hasUnsavedChanges } = useSelector((state: RootState) => state.unsavedChangesSlice);
	const { autosaveStatus } = useSelector((state: RootState) => state.reportsSlice);

	const unsavedChanges = module_type === ModuleType.Reports ? hasUnsavedChangesReports(autosaveStatus) : hasUnsavedChanges;

	const websocketService =
		module_type === ModuleType.Reports ? websocketReportService : module_type === fileTypes.discussion_guide ? websocketDiscussionGuideService : websocketTranscriptService;

	// Block navigation when there are unsaved changes
	const blocker = useBlocker(({ currentLocation, nextLocation }) => unsavedChanges && currentLocation.pathname !== nextLocation.pathname);

	// Handle the blocker state change
	useEffect(() => {
		if (blocker.state === "blocked" && unsavedChanges) {
			// You can trigger your custom modal here
			// For now, using confirm as fallback
			const shouldLeave = window.confirm(t("You have unsaved changes, are you sure you want to leave?"));

			if (shouldLeave) {
				if (module_type === fileTypes.segment || module_type === fileTypes.transcript || module_type === fileTypes.discussion_guide) {
					onConfirm();
				} else {
					blocker.proceed?.();
				}
			} else {
				blocker.reset?.();
			}
		}
	}, [blocker.state, module_type, onConfirm, unsavedChanges]);

	// Handle page refresh/close
	useEffect(() => {
		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			if (unsavedChanges) {
				event.preventDefault();
				event.returnValue = "";
				if (module_type !== fileTypes.segment) {
					setTimeout(() => websocketService.handlePageLoadReconnection(), 100);
				}
			}
		};

		window.addEventListener("beforeunload", handleBeforeUnload);

		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [unsavedChanges, module_type, websocketService]);

	return null;
};

export default LeavePagePrompt;
